<p-dialog
  header="Cancel Order"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onShow)="onShow()"
>
  <div *ngIf="!loading; else loadingView">
    <div class="ui-grid-row ui-grid-responsive ui-fluid">
      <span>
        This action will cancel/abort the order. The standard fee for this is £{{
          customerChargedPrice | number : '1.2-2'
        }}
        do you want to apply this or not?
      </span>
    </div>

    <div
      class="ui-grid-row ui-grid-responsive ui-fluid"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <div class="ui-grid-col-4">Supplier Payment</div>
      <div class="ui-grid-col-4">
        <input
          [formControl]="formGroup.controls.newSupplierChargedPrice"
          [style]="{ width: '100%' }"
          pInputText
          maxlength="10"
          (keydown)="inputHelper.allowNumberInputKey($event)"
          (keyup)="inputHelper.fixDigitsAndMax($event.target, 10000)"
        />
      </div>
    </div>

    <div
      class="ui-grid-row ui-grid-responsive ui-fluid"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <div class="ui-grid-col-4">Cancellation Charge</div>
      <div class="ui-grid-col-4">
        <input
          [formControl]="formGroup.controls.newCustomerChargedPrice"
          [style]="{ width: '100%' }"
          pInputText
          maxlength="10"
          (keydown)="inputHelper.allowNumberInputKey($event)"
          (keyup)="inputHelper.fixDigitsAndMax($event.target, 10000)"
        />
      </div>
    </div>

    <div
      class="ui-grid-row ui-grid-responsive ui-fluid"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <div class="ui-grid-col-4">Cancellation Status</div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="cancellationStatusOptions"
          appendTo="body"
          [style]="{ width: '100%' }"
          (onChange)="onCancellationStatusChange()"
          [formControl]="formGroup.controls.cancellationStatusId"
        >
        </p-dropdown>
      </div>
    </div>

    <div
      *ngIf="displaySecondaryCancellation"
      class="ui-g"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <div class="ui-grid-col-4">Secondary cancellation status</div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="secondaryCancellationStatusOptions"
          autoWidth="false"
          appendTo="body"
          [style]="{ width: '100%' }"
          [formControl]="formGroup.controls.secondaryCancellationStatusId"
        >
        </p-dropdown>
      </div>
    </div>

    <div
      class="ui-grid-row ui-grid-responsive ui-fluid"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <div class="ui-grid-col-4">Why are you cancelling this order?</div>
      <div class="ui-grid-col-8">
        <textarea
          [formControl]="formGroup.controls.cancellationDescription"
          [style]="{ width: '100%' }"
          pInputTextarea
          [rows]="3"
        ></textarea>
      </div>
    </div>

    <div class="flex gap-2 border-2 border-gray-300 border-solid flex gap-2 p-2">
      <div>
        <p-checkbox
          binary="true"
          label=""
          [formControl]="formGroup.controls.copyOrder"
        ></p-checkbox>
      </div>
      <div>
        <div>
          Create Order Copy
          <i
            class="fa fa-info-circle cursor-pointer text-primary"
            (click)="copyOrderPanel.toggle($event)"
          ></i>
        </div>
      </div>
    </div>
  </div>

  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <button
      type="button"
      (click)="visibleChange.emit(false)"
      pButton
      label="Close"
      class="ui-button ui-button-tertiary"
    ></button>

    <button
      type="button"
      (click)="cancelOrder(true)"
      pButton
      [disabled]="loading || formGroup.invalid"
      label="Cancel With Fee"
      class="ui-button ui-button-danger"
    ></button>
    <button
      type="button"
      (click)="cancelOrder(false)"
      pButton
      [disabled]="loading || formGroup.invalid"
      label="Cancel Without Fee"
      class="ui-button ui-button-primary"
    ></button>
  </p-footer>
</p-dialog>

<ng-template #loadingView>
  <div
    class="flex align-items-center justify-content-center w-full"
    style="height: 270px; font-size: 25px"
  >
    <i class="fa fa-spin fa-spinner"></i>
  </div>
</ng-template>

<p-overlayPanel #copyOrderPanel>
  <div>
    Create a new copy of this order inside a new job.<br />
    The customer <b>will not</b> be sent an order confirmation email.<br />
    Urgency will be based on the original order created date
  </div>
</p-overlayPanel>
